"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceActivationResult = void 0;
var PlaceActivationResult;
(function (PlaceActivationResult) {
    PlaceActivationResult["successful"] = "successful";
    PlaceActivationResult["alreadyActivated"] = "alreadyActivated";
    PlaceActivationResult["tokenInvalid"] = "tokenInvalid";
})(PlaceActivationResult || (exports.PlaceActivationResult = PlaceActivationResult = {}));
//# sourceMappingURL=PlaceActivationResult.js.map